// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__1CKPY","calendarButtons":"ClockData_calendarButtons__25zvA"};